<template>
    <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
        <div class="kgr-grid__cell kgr-inputGroup">
            <kgr-form-row
                v-if="!hideDepartmentSelect"
                :label="$t('team.department')"
                :error="error"
                field-name="departmentId"
                required
            >
                <kgr-department-select
                    hide-label
                    :value="department"
                    :club-id="clubId"
                    exclude-if-basic-data-not-viewable
                    @post-input="onDepartmentChange"
                    @optionsLoaded="departmentOptions = $event"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('team.name')"
                :error="error"
                field-name="name"
                required
            >
                <input
                    v-model.trim="team.name"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>
            <kgr-form-row
                :label="$t('Sportart')"
                :error="error"
                field-name="sportId"
            >
                <kgr-generic-select
                    :model-value="team.sportId"
                    :options="sportOptions"
                    :loading="sportsLoading"
                    display="name"
                    option-key="id"
                    :default-text="$t('Keine Angabe')"
                    @update:model-value="onSportChange"
                />
            </kgr-form-row>

            <kgr-form-row
                :error="error"
                field-name="hideMembersFromEachOther"
            >
                <kgr-checkbox
                    :model-value="!team.hideMembersFromEachOther"
                    :label="$t('Mitglieder für andere sichtbar')"
                    class="kgr-row mt1"
                    @update:model-value="team.hideMembersFromEachOther = !$event"
                />
            </kgr-form-row>

            <kgr-form-row
                :error="error"
                field-name="enableChat"
            >
                <kgr-checkbox
                    v-model="team.enableChat"
                    :label="$t('Team-Chat aktiviert')"
                    class="kgr-row mt1"
                />
            </kgr-form-row>
        </div>

        <div
            v-if="!hideImageUpload"
            class="kgr-grid__cell"
        >
            <kgr-team-image-form-row :team="team" />
        </div>
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox';
import DepartmentSelect from '../common/form/select/DepartmentSelect';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import GenericSelect from '../common/form/select/GenericSelect';
import KgrTeamImageFormRow from './ImageFormRow';
import SportsRepository from '../../js/repository/SportsRepository';
import Team from '../../js/dto/Team';

export default {
    name: 'KgrTeamBasicDataForm',
    components: {
        'kgr-team-image-form-row': KgrTeamImageFormRow,
        'kgr-checkbox': Checkbox,
        'kgr-department-select': DepartmentSelect,
        'kgr-form-row': FormRow,
        'kgr-generic-select': GenericSelect,
    },
    props: {
        team: {
            type: Team,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
        hideDepartmentSelect: {
            type: Boolean,
            default: false,
        },
        hideImageUpload: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            departmentOptions: [],
            sports: [],
            sportsLoading: true,
        };
    },
    computed: {
        department() {
            return this.departmentOptions.find(team => this.team.departmentId !== null && team.id === this.team.departmentId);
        },
        sportOptions() {
            return this.sports
                .filter(sport => !sport.isArchived)
                .map(sport => ({
                    id: sport.id,
                    name: sport.name,
                }));
        },
    },
    created() {
        this.loadSports();
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
        onDepartmentChange(department) {
            this.team.departmentId = department === null ? null : department.id;
        },
        onSportChange(sport) {
            this.team.sportId = sport === null ? null : sport.id;
        },
        loadSports() {
            SportsRepository
                .findAll(this.clubId)
                .then(sports => {
                    this.sports = sports;
                    this.sportsLoading = false;
                })
                .catch(() => {
                    this.$notify.error('error.loadingData');
                    this.sportsLoading = false;
                });
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
